/**
 * @constructor
 * @returns {GameConfig}
 */
export function GameConfig() {

	this.symbolPosY = -70;

	this.reelsPositions = [
		{ 'x': 122 + 30, 'y': this.symbolPosY },
		{ 'x': 244 + 122 + 30, 'y': this.symbolPosY },
		{ 'x': 244 * 2 + 122 + 30, 'y': this.symbolPosY },
		{ 'x': 244 * 3 + 122 + 30, 'y': this.symbolPosY },
		{ 'x': 244 * 4 + 122 + 30, 'y': this.symbolPosY }
	];

	this.ropesPos = [15, 244 + 30, 244 * 2 + 30, 244 * 3 + 30, 244 * 4 + 30, 1265];

	this.rowsCount = 3;

	this.symbolHeight = 210;
	this.symbolOffsetY = -4;

	this.hidePos = -9999;

	this.showPreinfo = true;

	this.reelStopInitSound = 1;
	this.reelStartInitSound = 1;
}